export default __webpack_public_path__ + "static/media/logoExtended.96121658.png";